import * as Accordion from "@radix-ui/react-accordion";
import { forwardRef, PropsWithChildren } from "react";
import * as SC from "./item.styles";

export interface AccordionItemProps extends SC.FrameProps {
  id: string;
}

export const Item = forwardRef<
  HTMLDivElement,
  PropsWithChildren<AccordionItemProps>
>(({ children, id, ...props }, ref) => {
  return (
    <Accordion.Item value={id} ref={ref} asChild>
      <SC.Frame {...props}>{children}</SC.Frame>
    </Accordion.Item>
  );
});

Item.displayName = "CustomTriggerAccordionGroup.Item";
